if ($('.ajax-content-sec').length) {
  loadShopFloor();
}

$('.tabs .tab a').on('click', function (e) {
  e.preventDefault();
  $('.tabs .tab a').removeClass('current');
  $(this).addClass('current');

  let targetUrl = '';
  switch ($(this).attr('href')) {
    case '#floor': targetUrl = '/shop-floor/'; break;
    case '#category': targetUrl = '/shop-category/'; break;
    case '#abc-order': targetUrl = '/shop-abc/'; break;
  }

  if (targetUrl) loadContent(targetUrl);
});

function loadShopFloor() {
  const $loading = createLoadingElement();
  $('.ajax-content-sec').fadeOut(300, function () {
    $(this).html($loading).fadeIn(300);
  });
  loadContent('/shop-floor/');
}

function createLoadingElement() {
  return $('<div class="loading-container">')
    .append('<div class="loading"></div>')
    .append('<div class="loading-text">LOADING... <span class="loading-percentage">0%</span></div>');
}

let currentAjaxRequest = null;

function loadContent(targetUrl) {
  // 進行中のAjaxリクエストがあればアボート
  if (currentAjaxRequest) {
    currentAjaxRequest.abort();
  }

  // 進行中のアニメーションをすべて停止
  $('.ajax-content-sec').stop(true, true);

  const $loading = createLoadingElement();
  $('.ajax-content-sec').fadeOut(300, function () {
    $(this).html($loading).fadeIn(300);
  });

  const nocacheUrl = targetUrl + (targetUrl.includes('?') ? '&' : '?') + '_=' + new Date().getTime();

  // 新しいAjaxリクエストを開始
  currentAjaxRequest = $.ajax({
    url: nocacheUrl,
    method: 'GET',
    xhrFields: {
      withCredentials: true
    },
    success: function (response) {
      const $content = $(response);
      const $images = $content.find('img');
      const totalImages = $images.length;
      let loadedImages = 0;

      const updateProgress = () => {
        loadedImages++;
        const percentage = Math.round((loadedImages / totalImages) * 100);
        $('.loading-percentage').text(percentage + '%');
        //console.log(`Loading: ${loadedImages}/${totalImages} (${percentage}%)`);
      };

      if (totalImages === 0) {
        showContent(response);
        return;
      }

      const imagePromises = Array.from($images).map(img => {
        return new Promise((resolve) => {
          const image = new Image();

          image.onload = () => {
            updateProgress();
            resolve();
          };

          image.onerror = () => {
            console.warn(`Failed to load image: ${img.src}`);
            updateProgress();
            resolve();
          };

          const imgUrl = img.src + (img.src.includes('?') ? '&' : '?') + '_=' + new Date().getTime();
          image.src = imgUrl;
        });
      });

      const timeoutPromise = new Promise(resolve => {
        setTimeout(() => {
          if (loadedImages < totalImages) {
            $('.loading-text').html('読み込みを続けています...<br>しばらくお待ちください');
          }
          resolve();
        }, 5000);
      });

      Promise.race([
        Promise.all(imagePromises),
        timeoutPromise
      ]).then(() => {
        showContent(response);
      }).catch(error => {
        console.error('Loading error:', error);
        showContent(response);
      });
    },
    error: function (xhr, status, error) {
      if (status === 'abort') {
        console.log('Request aborted');
        return;
      }
      console.error('Ajax error:', error);
      $('.loading-text').text('読み込みに失敗しました');
      setTimeout(() => {
        $('.ajax-content-sec').fadeIn(300);
      }, 1000);
    },
    complete: function () {
      currentAjaxRequest = null; // リクエスト完了後にnullに設定
    }
  });
}

function showContent(response) {
  //console.log('Showing content...');

  $('.ajax-content-sec')
    .stop(true, true) // アニメーションを即座に完了
    .hide()
    .html(response)
    .css('opacity', 0)
    .show();

  $('.floor-buttons')
    .stop(true, true) // アニメーションを即座に完了
    .css('opacity', 0)
    .show();

  setTimeout(() => {
    requestAnimationFrame(() => {
      $('.ajax-content-sec').animate({
        opacity: 1
      }, 300, function () {
        $('.floor-buttons').animate({
          opacity: 1
        }, 300);

        initializeFloorFunctions();
        console.log('Content display completed');
      });
    });
  }, 100);
}

function initializeFloorFunctions() {
  // 初期表示（最初のフロアを表示）
  const firstFloor = document.querySelector('.floor-section');
  if (firstFloor) firstFloor.classList.add('active');

  // ボタンクリックイベント
  const buttons = document.querySelectorAll('.floor-btn');
  buttons.forEach(button => {
    button.addEventListener('click', function () {
      const floor = this.getAttribute('data-floor');

      document.querySelectorAll('.floor-section').forEach(section => {
        section.classList.remove('active');
      });

      const targetSection = document.querySelector(`.floor-section[data-floor="${floor}"]`);
      if (targetSection) targetSection.classList.add('active');

      buttons.forEach(btn => {
        btn.classList.remove('active', 'current');
      });
      this.classList.add('active', 'current');
    });
  });

  // 初期状態の設定
  const firstButton = document.querySelector('.floor-btn');
  if (firstButton) {
    firstButton.classList.add('active', 'current');
  }

  const firstFloorSection = document.querySelector('.floor-section');
  if (firstFloorSection) {
    firstFloorSection.classList.add('active');
  }
}
